import styled from "@emotion/styled";

export const MutedText = styled.div<{ danger?: boolean }>`
  font-size: 0.85em;
  color: rgba(0, 0, 0, 0.6);
`;
